import { appConfig } from '../constants/app-config';
import { jsDataModule } from '../vendor/js-data';

export const jsDataConfigModule = angular
  .module('Q.config.js-data', [jsDataModule])

  .run(function (DS, DSHttpAdapter, $log) {
    // make sure we always re-query the local store on cached remote calls, in case the result as changed
    DS.defaults.useFilter = true;
    DSHttpAdapter.defaults.basePath = appConfig.apiRoot;
    DSHttpAdapter.defaults.log = $log.debug;
    DSHttpAdapter.defaults.error = $log.error;
  });
